import { create } from "zustand"
import { ProfileCommunity } from "@/app/entities/BFF/ProfileShort"

interface FollowingsState {
  followings: ProfileCommunity[]
  setFollowings: (data: ProfileCommunity[]) => void
  clearFollowings: () => void
  addFollowing: (follower: ProfileCommunity) => void
  deleteFollowing: (id: string) => void
  isLoading: boolean | null
  setIsLoading: (loading: boolean) => void
  hasMore: boolean
  setHasMore: (hasMore: boolean) => void
}

export const useFollowingsStore = create<FollowingsState>((set) => ({
  followings: [],
  setFollowings: (data) => set({ followings: data }),
  clearFollowings: () => set({ followings: [], isLoading: null }),
  addFollowing: (follower) =>
    set((state) => {
      // 이미 같은 id가 있으면 추가하지 않음
      const exists = state.followings.some(
        (following) => following.id === follower.id,
      )
      if (exists) {
        return state
      }
      return {
        followings: [follower, ...state.followings],
      }
    }),
  deleteFollowing: (id) =>
    set((state) => ({
      followings: state.followings.filter((following) => following.id !== id),
    })),
  isLoading: null,
  setIsLoading: (loading) => set({ isLoading: loading }),
  hasMore: true,
  setHasMore: (hasMore) => set({ hasMore: hasMore }),
}))
